import React from "react";

const columnMap = [
  { name: "Name", isRelevant: () => true },
  { name: "Campus / Shliach", isRelevant: () => true },
  { name: "Type", isRelevant: (_, isTravelTrip) => !isTravelTrip },
  { name: "Venue", isRelevant: (_, isTravelTrip) => !isTravelTrip },
  { name: "Status", isRelevant: (isCheckInEnabled, _) => isCheckInEnabled },
];

function AttendeesTableHeader(props) {
  const {
    canSelectAttendees,
    isCheckInEnabled,
    isTravelTrip,
    readOnlyAccess,
    selectedAttendees,
    toggleSelectAllAttendees,
  } = props;

  const columns = columnMap
    .filter((col) => col.isRelevant(isCheckInEnabled, isTravelTrip))
    .map((col) => col.name);

  return (
    <div
      className={`attendees-table-columns${
        !isCheckInEnabled ? " compact" : ""
      } trip-students-table-header${readOnlyAccess ? " read-only" : ""}`}
    >
      {!readOnlyAccess && isCheckInEnabled && (
        <div className="flex flex-align-center custom-checkbox-container">
          <input
            className="custom-checkbox"
            checked={
              selectedAttendees.all && !selectedAttendees.allExcept.length
            }
            disabled={!canSelectAttendees}
            id="all-attending"
            onChange={toggleSelectAllAttendees}
            type="checkbox"
          />
          <label className="flex-align-center" htmlFor="all-attending" />
        </div>
      )}
      {columns.map((column, index) => (
        <p className="flex flex-align-center relative" key={index}>
          {column}
        </p>
      ))}
    </div>
  );
}
export default React.memo(AttendeesTableHeader);
